module.exports = __webpack_public_path__ + "img/buyHomeBannerPhone.36a3ece8.png";